import { builder } from '../../../../../common/js/configs';

export const commonUseBorderLayer = {
  useBorderLayer: builder.boolean('use_border_layer', {
    defaultValue: true,
    d:''
  })
};
